import { AgentSearchService } from 'ag-common-svc/public-api';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import CustomStore from 'devextreme/data/custom_store';
import { Agent, Agency, ActiveLookup } from 'ag-common-lib/public-api';
import { SessionControllerService } from 'src/app/shared/services/util/session-controller.service';
import { AgentService, AgencyService, LookupsService } from 'ag-common-svc/public-api';
import { AgentsService } from '../../agents/agents.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-agents-selection',
  templateUrl: './agents-selection.component.html',
  styleUrls: ['./agents-selection.component.scss'],
})
export class AgentsSelectionComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onAgentsSelected: EventEmitter<Agent[]> = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();

  @Input() selectedAgentKeys: string[] = [];

  selectedAgents: any = [];

  dataSource = {};

  agencies: Agency[] = [];
  public prefixesLookup$: Observable<ActiveLookup[]>;
  public dietaryConsiderationTypesLookup$: Observable<ActiveLookup[]>;

  constructor(
    agentsService: AgentsService,
    public router: Router,
    public session: SessionControllerService,
    public agentService: AgentService,
    public agentSearchService: AgentSearchService,
    public agencyService: AgencyService,
    lookupsService: LookupsService,
  ) {
    this.prefixesLookup$ = lookupsService.prefixesLookup$;
    this.dietaryConsiderationTypesLookup$ = lookupsService.dietaryConsiderationTypesLookup$;
    this.dataSource = new CustomStore({
      key: 'dbId',
      loadMode: 'raw',
      load: function (loadOptions: any) {
        return agentSearchService
          .search({ sort: [{ selector: 'p_agent_first_name', desc: false }] })
          .then(response => response?.data ?? []);
      },
      insert: function (value: Agent) {
        value.p_email = value.p_email.toLowerCase();
        return agentService.create(value);
      },
      // The grid hands over only the edited fields, so this has to be a merge write.
      // `update()` is a bare setDoc: it REPLACES the document, deleting everything the
      // caller did not pass. The email is only normalized when it is one of them.
      update: function (key: any, value: Partial<Agent>) {
        if (value.p_email) {
          value.p_email = value.p_email.toLowerCase();
        }

        return agentService.updateAgentFields(key, value);
      },
      remove: function (id: any) {
        return agentService.delete(id);
      },
    });
  }

  ngOnInit(): void {
    this.agencyService.getAll().then(agency => {
      agency = agency.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));

      this.agencies = agency;
    });
  }

  showContactInfo(e) {
    this.session.selectAgent(e.data);
  }

  selectAgents() {
    this.onAgentsSelected.emit(this.selectedAgents);
    this.closeClicked();
  }

  closeClicked() {
    this.onClose.emit(true);
  }

  onSelectionChanged(e) {
    this.selectedAgents = e.selectedRowsData;
  }
}

export class Tab {
  id: number;
  text: string;
  template: string;
}
